export const sources = {
	webp: "__VITE_ASSET__DUq8YoikZLXEejpNZ1KQvg__ 400w, __VITE_ASSET__$oUiuAXR7gZMKRQU56HW2w__ 800w"
};
export const img = {
	src: "__VITE_ASSET__$oUiuAXR7gZMKRQU56HW2w__",
	w: 800,
	h: 1067
};
export default {
	sources: sources,
	img: img
};
